import React from 'react';
import ReportingFinancesGeneralLedgerPage from '../components/ReportingFinancesGeneralLedgerPage';

const ReportingFinancesGeneralLedgerApp = (props) => (
  <ReportingFinancesGeneralLedgerPage {...props} />
);

export default ReportingFinancesGeneralLedgerApp;
